"use client";
import BackgroundPattern from "@/assets/background-pattern.svg";
import { cn } from "@/lib/utils";

export default function Section({ id, wrapperClassName, className, children, as, backgroundPattern = false }) {
  const Element = as || "section";
  return (
    <Element id={id} className={cn("py-8 md:py-16 lg:py-20 relative overflow-hidden", wrapperClassName)}>
      <div className={cn("content relative z-10", className)}>{children}</div>
      {backgroundPattern && (
        <div className="absolute left-0 top-0 right-0 bottom-0 w-screen h-auto object-cover">
          <BackgroundPattern className="w-screen h-auto object-cover" />
          <div className="absolute left-0 top-0 right-0 bottom-0 w-screen h-auto object-cover bg-linear-to-r from-muted to-muted/30" />
        </div>
      )}
    </Element>
  );
}
